import script from "./MCF_SC_001.vue?vue&type=script&setup=true&lang=js"
export * from "./MCF_SC_001.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__